module.exports = __webpack_public_path__ + "static/media/banner.aed34c47.png";